/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedPaymentListDto } from '../models/PaginatedPaymentListDto';
import type { PaymentDto } from '../models/PaymentDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PaymentsService {
  /**
   * @returns PaginatedPaymentListDto
   * @throws ApiError
   */
  public static paymentControllerFindAllWithPagination({
    sort,
    filter,
    page = 1,
    itemsPerPage = 30,
  }: {
    sort?: string;
    /**
     * Filter options: exact match, ilike, between, in
     */
    filter?: string;
    page?: number;
    itemsPerPage?: number;
  }): CancelablePromise<PaginatedPaymentListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payments',
      query: {
        sort: sort,
        filter: filter,
        page: page,
        itemsPerPage: itemsPerPage,
      },
    });
  }

  /**
   * @returns PaymentDto
   * @throws ApiError
   */
  public static paymentControllerFindById({
    id,
    filter,
  }: {
    id: number;
    /**
     * Filter options: exact match, ilike, between, in
     */
    filter?: string;
  }): CancelablePromise<PaymentDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payments/{id}',
      path: {
        id: id,
      },
      query: {
        filter: filter,
      },
    });
  }
}
